import PUMSProvider from '@amzn/PassportUserManagementUIAssets/dist/PUMSProvider';
import AppLayout from '@amzn/meridian/app-layout';
import React, { useCallback, useState } from 'react';
import { useLocation } from 'react-router';
import LpHeader from '../components/LpHeader';
import Footer from '../components/homePage/Footer';
import withIntl from '../hoc/withIntl';
import routes from '../routes';
import { shouldRenderHeader } from '../utils/authorizedPageUtils';
import SideNavMenu from './SideNavMenu';
import TopBar from './TopBar';
import UnAuthorizedAlert from './UnAuthorizedAlert';

const Layout = ({ isLoading }) => {
  const [sideMenuState, setSideMenuState] = useState(false);
  const { pathname } = useLocation();
  const showLpHeader = shouldRenderHeader(pathname);
  const onToggleSideMenu = useCallback(() => {
    setSideMenuState(!sideMenuState);
  }, [sideMenuState]);
  const onCloseSideMenu = useCallback(() => {
    setSideMenuState(false);
  }, []);
  return (
    <AppLayout
      headerComponent={TopBar}
      sidebarComponent={SideNavMenu}
      footerComponent={Footer}
    >
      <PUMSProvider>
        <TopBar onClick={onToggleSideMenu} />
      </PUMSProvider>
      <SideNavMenu isMenuOpened={sideMenuState} onClose={onCloseSideMenu} />
      <UnAuthorizedAlert />
      {showLpHeader && <LpHeader />}
      {!isLoading && routes}
      <Footer />
    </AppLayout>
  );
};

export default withIntl(Layout);
